import { Link } from "react-router-dom";
import ButtonV2 from "../../components/ButtonV2";

const NewsBig = (props) => {
  const date = new Date(props.date);
  const month = date.toLocaleString("default", { month: "long" });
  const day = date.getDate();
  const year = date.getFullYear();

  return (
    <div className="d-flex flex-column flex-lg-row">
      <img
        src={props.image}
        alt={props.alt}
        className="col-12 col-lg-6 pt-3 pb-3"
      />
      <div className="col-12 col-lg-6 d-flex flex-column p-3">
        <h3>
          {props.title.slice(0, 55)}
          {props.title.length > 55 ? "..." : ""}
        </h3>
        <span className="pb-3">
          <b>
            {day}. {month} {year}
          </b>
        </span>
        <p>{props.overview.slice(0, 200)}...</p>
        <Link to={`/aktuality/detail/${props.id}`}>
          <ButtonV2 text="Více" />
        </Link>
      </div>
    </div>
  );
};
export default NewsBig;
